import React from 'react';
import { SvgCloseIcon } from '../svg';
import { connect } from 'react-redux'



class MultiAnsModal extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            answer: {}
        }

        this.addMultiAnswer = this.addMultiAnswer.bind(this)
        this.onCheckBoxClick = this.onCheckBoxClick.bind(this)
    }

    componentDidMount(){
        if (Object.keys(this.state.answer).length === 0) {
            let defaults = {};
            this.props.question.value.questions.map((q,i) => {
                let qAccessor = q
                if (q.value) {
                    qAccessor = q.value
                }
                if (qAccessor.block_type === "boolean") {
                    defaults[i] = false
                } else {
                    defaults[i] = ''
                }
            });
            this.setState(defaults);   
        }
    }

    shouldBeDisabled(condition_check){
        const questions = this.props.question.value.questions;
        let counter = 0
        let lastKey = questions[questions.length - 1].id;
        Object.keys(this.state.answer).forEach((key) => {
            if (this.state.answer[key] === '' || !this.state.answer[key]) {
                counter -= 1 
            }
            counter += 1
        });
        switch (condition_check) {
            case "allTrue":
                return !(counter == questions.length)
            case "anyTrue":
                return !(counter > 0);
            case "allFalse":
                return !(counter === 0)
            case "anyFalse":
                return !(counter < questions.length)
            case "lastTrue":
                return !(this.state.answer[lastKey] && this.state.answer[lastKey] !== '')
        }
    }

    selectAnswer(index, e) {
        let val = '';
        if (e  === false) {
            val = e;
        } else if (e.currentTarget.type === 'checkbox') {
            val = e.target.checked;
        } else {
            val = e.target.value;
        }
        if (val === "") {
            delete this.state.answer[index]
        } else {
            this.setState({
                answer :{
                    ...this.state.answer,
                    [index]: val
                }
            })
        }
    }

    addMultiAnswer(questionType, questionId, canBeCopied, dispCond, e) {
        let ansArr = [];
        Object.keys(this.state.answer).map((ans) => ansArr.push(this.state.answer[ans]));
        this.props.addMultiAnswer(questionType, ansArr, questionId, this.props.subgroup, this.props.groupTitle, canBeCopied, dispCond);
        this.setState({
            answer: {}
        })
    }

    renderValue(i) {
        let val = "";
        if (this.state.answer[i]) {
            val = this.state.answer[i]
        }
        return val;
    }

    onCheckBoxClick(e) {
        console.log(e);
    }

    renderQuestions(questions, questionId) {
        let allQuestions = [];
        const id_prefix = this.props.customerId + "-" + this.props.offerType + "-" + questionId;
        if (this.props.conditionalQuestion) {
            allQuestions = questions.map((q, i) => {
                let qAccessor = q
                if (q.value) {
                    qAccessor = q.value
                }
                if (qAccessor.block_type === "text") {
                    return (<div className="qa">
                        <label className="question" htmlFor={id_prefix+ "-" + i}>{qAccessor.label} {qAccessor.help_text && <small>{qAccessor.help_text}</small>}</label>
                        <input className="answer input" type="text" id={id_prefix+ "-" + i} onChange={(e) => this.selectAnswer(i, e)} value={this.renderValue(i)} ></input>

                    </div>)
                } else if (qAccessor.block_type === "boolean") {
                    return (<div className="checkbox">
                        <input type="checkbox" id={id_prefix+ "-" + i} name={id_prefix+ "-" + i} value={qAccessor.label} onChange={(e) => this.selectAnswer(i, e)} checked={this.renderValue(i)} onClick={(e) => this.onCheckBoxClick(e)}></input>
                        <label htmlFor={id_prefix+ "-" + i}></label>
                        <label className="text" htmlFor={id_prefix+ "-" + i}>{qAccessor.label}</label>
                    </div>)
                }
            })
        } else {
            allQuestions = questions.map((q, i) => {
                let qAccessor = q
                if (q.value) {
                    qAccessor = q.value
                }

                return(
                    <div className="qa">
                        <label className="question" htmlFor={id_prefix+ "-" + i}>{qAccessor.label}</label>
                        <input className="answer input" type="text" id={id_prefix+ "-" + i} onChange={(e) => this.selectAnswer(i, e)} value={this.renderValue(i)}></input>

                    </div>
                )
            })
        }
        return allQuestions;
    }

    render() {
        let questions = [];
        let questionId = this.props.questionId;
        let canBeCopied = this.props.canBeCopied;

        questions = this.props.question.value.questions;
        let question_group_condition = this.props.question.value.condition ?? 'allTrue';
        return (

            <div className="modal multi-ans-modal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" id={this.props.id}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            {/* <SvgCloseIcon/> */}
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true"><SvgCloseIcon/></span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {this.renderQuestions(questions, questionId)}
                            <button disabled={this.shouldBeDisabled(question_group_condition)} className="btn btn-primary" type="button" onClick={(e) => this.addMultiAnswer(this.props.conditionalQuestion ? 'conditional' : 'normal', this.props.conditionalQuestion ? questionId + "-0" : questionId, canBeCopied, this.props.dispCond, e)} data-dismiss="modal">Vista</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default MultiAnsModal;